import { APP_IDS, type AppId } from '@omnia/shared';
import { LOCALE } from '../lib/i18n.ts';

/** Apps whose title contains the typed text, in dock order; an empty search lists them all. */
export function filterApps(query: string, titleOf: (id: AppId) => string): AppId[] {
  const needle = query.trim().toLocaleLowerCase(LOCALE);
  if (!needle) return [...APP_IDS];
  return APP_IDS.filter((id) => titleOf(id).toLocaleLowerCase(LOCALE).includes(needle));
}
